import type { SupabaseClient } from "@supabase/supabase-js";

export type OrgLocationRow = {
  id: string;
  name: string;
  location_code?: string | null;
  city?: string | null;
  social_facebook_page_id?: string | null;
};

const LOCATIONS_SELECT = "id, name, location_code, city, social_facebook_page_id" as const;

/** Pilot DB uses `organization_id` on `locations`; legacy envs may use `org_id`. */
export async function fetchOrgLocations(
  client: SupabaseClient,
  orgId: string,
): Promise<{ data: OrgLocationRow[]; error: string | null }> {
  let q = await client
    .from("locations")
    .select(LOCATIONS_SELECT)
    .eq("organization_id", orgId)
    .order("name", { ascending: true });

  if (q.error && /location_code|column.*does not exist|42703/i.test(q.error.message)) {
    const fallback = await client
      .from("locations")
      .select("id, name, social_facebook_page_id")
      .eq("organization_id", orgId)
      .order("name", { ascending: true });
    if (!fallback.error) {
      return { data: (fallback.data ?? []) as unknown as OrgLocationRow[], error: null };
    }
    q = fallback as typeof q;
  }

  if (q.error && /org_id|column.*does not exist|42703/i.test(q.error.message)) {
    q = await client.from("locations").select(LOCATIONS_SELECT).eq("org_id", orgId).order("name", { ascending: true });
  }
  if (q.error) return { data: [], error: q.error.message };
  return { data: (q.data ?? []) as unknown as OrgLocationRow[], error: null };
}
